import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { isFalsy } from 'utility-types';
import { CreateKeyValueRequest } from '@models/base/createKeyValueRequest.model';
import { UpdateKeyValueRequest } from '@models/base/updateKeyValueRequest.model';

@Injectable({
  providedIn: 'root'
})
export class PropiedadClaseService {

  constructor(
    private http: HttpClient
  ) { }

  getById(id: number): Observable<BaseDto> {
    return this.http.get<BaseDto>("/api/PropiedadClase/GetById?id=" + id)
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/PropiedadClase/Delete?id=" + id);
    else
      return of(null)
  }

  create(createKeyValueRequest: CreateKeyValueRequest): Observable<CreateResponseBase> {
    return this.http.post<CreateResponseBase>("/api/PropiedadClase/Create", createKeyValueRequest);
  }

  update( updateKeyValueRequest: UpdateKeyValueRequest): Observable<any> {
    return this.http.put<any>("/api/PropiedadClase/Update", updateKeyValueRequest);
  }

  getAll(): Observable<BaseDto[]> {
    return this.http.get<BaseDto[]>("/api/PropiedadClase/GetAll");
  }

}
